import createReactClass from 'create-react-class';

export default function (dependencies) {
  const HTML = createReactClass({
    render() {
      var field = this.props.field;

      const html = `<div class="lz-input-wrapper">
          <div
            class="lz-alert"
            style="display:block">
            ${field.state.value}
            </div>
        </div>`;

      return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
    },
  });

  return {
    html: HTML,
    config: {
      ignored: true,
    },
  };
}
